import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ModalContextConsumer } from '../../../contexts/modalContext';
import { IHeaderMenuProps, IModalProps, IResizeOption } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function HeaderMenu(props: IHeaderMenuProps): JSX.Element {
  const { onRemove, onToggleEditing, isEditing, isEditable, resizeOptions, onResize, canCreateNew, onCreateNew } =
    props;
  const { t } = useTranslation();
  const [isOpened, setOpened] = useState(false);

  const toggle = () => {
    setOpened(!isOpened);
  };

  const OnResize = (ro: IResizeOption) => {
    if (onResize) {
      onResize(ro);
      setOpened(false);
    }
  };

  const toggleEditing = (save?: boolean) => {
    if (onToggleEditing) {
      onToggleEditing(save);
    }
    setOpened(false);
  };

  const onCreate = () => {
    if (onCreateNew) {
      onCreateNew();
      setOpened(false);
    }
  };

  const deleteAction = (openModal: (modal: IModalProps) => void) => {
    openModal({
      key: 'delete-tile-modal',
      message: t('cockpit.removeModal.message'),
      info: t('cockpit.removeModal.info'),
      confirmText: t('cockpit.removeModal.confirmText'),
      abortText: t('cockpit.removeModal.abortText'),
      onAbort: () => {
        setOpened(false);
      },
      onConfirm: () => {
        onRemove();
        setOpened(false);
      },
    });
  };

  return (
    <>
      {!isEditing && (
        <button type="button" className="threedot" onClick={toggle}>
          {!isOpened && <span className="ic-menu-dots" />}
          {isOpened && <span className="ic-close" />}
        </button>
      )}

      {isEditing && (
        <>
          <button
            type="button"
            className="threedot"
            onClick={() => {
              if (onToggleEditing) {
                onToggleEditing(false);
              }
            }}
          >
            <span className="ic-close" />
          </button>

          <button
            type="button"
            className="threedot"
            onClick={() => {
              if (onToggleEditing) {
                onToggleEditing(true);
              }
            }}
          >
            <span className="ic-checked" />
          </button>
        </>
      )}

      {isOpened && (
        <>
          <div className="context-blocker" />
          <div className="menu-context">
            <ModalContextConsumer>
              {({ openModal }) => (
                <ul>
                  {/* <li>
                    <a>
                      <span className="icon ic-externalLink" aria-hidden="true" />
                      Verschieben
                    </a>
                  </li> */}

                  {/* RESIZE BUTTON */}
                  {resizeOptions?.length
                    ? resizeOptions?.map((ro) => {
                        return (
                          <li key={`resize-option-${ro.w}x${ro.h}`}>
                            <a
                              onClick={() => {
                                OnResize(ro);
                              }}
                              onKeyPress={(e) => {
                                keyboardTriggerBasic(e, () => {
                                  OnResize(ro);
                                });
                              }}
                              className="link"
                              role="button"
                              tabIndex={0}
                            >
                              <span className="icon ic-maximize" aria-hidden="true" />
                              <span className="link-text">{t(ro.title)}</span>
                            </a>
                          </li>
                        );
                      })
                    : ''}

                  {/* EDIT BUTTON */}
                  {isEditable && (
                    <li>
                      <a
                        onClick={() => {
                          toggleEditing();
                        }}
                        onKeyPress={(e) => {
                          keyboardTriggerBasic(e, () => {
                            toggleEditing();
                          });
                        }}
                        className="link"
                        role="button"
                        tabIndex={0}
                      >
                        <span className="icon ic-settings" aria-hidden="true" />
                        <span className="link-text">
                          <Trans i18nKey="cockpit.header.edit">Bearbeiten</Trans>
                        </span>
                      </a>
                    </li>
                  )}

                  {/* DELETE BUTTON */}
                  <li>
                    <a
                      onClick={() => {
                        deleteAction(openModal);
                      }}
                      onKeyPress={(e) => {
                        keyboardTriggerBasic(e, () => {
                          deleteAction(openModal);
                        });
                      }}
                      className="link"
                      role="button"
                      tabIndex={0}
                    >
                      <span className="icon ic-delete" aria-hidden="true" />
                      <span className="link-text">
                        <Trans i18nKey="cockpit.header.remove">Löschen</Trans>
                      </span>
                    </a>
                  </li>

                  {/* ADD BUTTON */}
                  {canCreateNew ? (
                    <li>
                      <a
                        onClick={() => {
                          onCreate();
                        }}
                        onKeyPress={(e) => {
                          keyboardTriggerBasic(e, () => {
                            onCreate();
                          });
                        }}
                        className="link"
                        role="button"
                        tabIndex={0}
                      >
                        <span className="icon ic-add" aria-hidden="true" />
                        <span className="link-text">
                          <Trans i18nKey="cockpit.header.new">Neu hinzufügen</Trans>
                        </span>
                      </a>
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              )}
            </ModalContextConsumer>
          </div>
        </>
      )}
    </>
  );
}
export default HeaderMenu;
